import { retryMeta } from '@/utils';
import { RetryConverter } from '@/containers';

import { Meta } from './segments';

const Retry = () => (
  <>
    <Meta {...retryMeta} robots />

    <main
      className="container py-4"
      style={{ minHeight: 'calc(100vh - 410px)' }}
    >
      <div className="text-center">
        <h1 className="mb-3">Retry Conversion</h1>
        <p className="text-muted mb-3">
          Retrying your failed conversion
        </p>
      </div>

      <RetryConverter />
    </main>
  </>
);

export default Retry;
